var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", xs: "12", sm: "12", md: "12", lg: "3" } },
            [
              _vm.loading_legajo
                ? _c("CardSkeletonList", { attrs: { count: 1 } })
                : _c("CardInfo", {
                    ref: "CardInfo",
                    attrs: { legajo: _vm.legajo },
                  }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", xs: "12", sm: "12", md: "12", lg: "9" } },
            [
              _vm.loading_legajo
                ? _c("CardSkeletonList", { attrs: { count: 3 } })
                : [
                    _c("CardPersonalData", {
                      ref: "CardPersonalData",
                      attrs: { legajo: _vm.legajo, service: _vm.service },
                    }),
                    _c("CardPersonalWork", {
                      ref: "CardPersonalWork",
                      attrs: { legajo: _vm.legajo },
                    }),
                    _c("CardContact", {
                      ref: "CardContact",
                      attrs: { legajo: _vm.legajo },
                    }),
                    _vm.legajo.id > 0
                      ? _c("CardAccess", { attrs: { legajo: _vm.legajo } })
                      : _vm._e(),
                  ],
            ],
            2
          ),
        ],
        1
      ),
      !_vm.loading_legajo
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  staticClass: "d-flex justify-end",
                  attrs: { cols: "12", md: "12" },
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        type: "submit",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.createItem },
                    },
                    [_vm._v(_vm._s(_vm.legajo.id > 0 ? "Editar" : "Guardar"))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }